import React from 'react';

export const Team = (props) => {
  return (
    <div
      id='team'
      className='text-center'
    >
      <div className='container'>
        <div className='col-md-8 col-md-offset-2 section-title'>
          <h2>Meet the Team</h2>
          <p>
            At Piegon's Communications, we pride ourselves on our dedicated team
            of professionals who work tirelessly to provide you with seamless,
            high-speed internet connectivity. Our team is a diverse group of
            experts, each bringing their unique skills and knowledge to ensure
            that you stay connected to the digital world. Allow us to introduce
            you to the faces behind your online experience:
          </p>
        </div>
        <div id='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.name}-${i}`}
                  className='col-md-4 col-sm-6 team'
                >
                  <div className='thumbnail'>
                    {' '}
                    <img
                      src={d.img}
                      alt='...'
                      className='team-img'
                      style={{ borderRadius: '5px' }}
                    />
                    <div className='caption'>
                      <h4 style={{ fontWeight: 'bolder' }}>{d.name}</h4>
                      <h5>{d.job}</h5>

                      <p>
                        {' '}
                        <i className='fa fa-phone'></i>{' '}
                        <span style={{ fontWeight: 'bold' }}> {d.phone}</span>
                      </p>

                      <p>{d.description}</p>
                    </div>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  );
};
